module.exports = __webpack_public_path__ + "static/media/1.02a258d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/3028/1.jpg
// module id = 649
// module chunks = 0